import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { CondicaoPagamentoTipoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CondicaoPagamentoTipoPipe
    ],
    exports: [
        CondicaoPagamentoTipoPipe
    ],
    providers: [
        CondicaoPagamentoTipoPipe
    ]
})
export class CondicaoPagamentoTipoModule { }
